let logoImg = 'https://velocitychannel.io/velocity-channel-logo.png'

export default logoImg
